import React from "react";
import moment from 'moment';
import { injectIntl } from 'react-intl';
import './SubscriptionPage.scss';

import { createStripePortalSession, createCustomerSession } from '../../helpers/api-calls/plan-calls';
import { getUserId } from '../../helpers/cookies';
import config from '../../config/environment';

class SubscriptionPage extends React.Component {
  state = {
    loading: true,
    path: null,
  };

  constructor(props) {
    super(props);

    this.state ={
      planName:[],
      planPrice:[],
      planUrl: [],
      planButtonText: [],
      planThirdLineText: [],
      planFourthLineText: [],
      customerSessionSecret: null,
      pricingTableLoading: false,
      checkoutSuccess: false,
      checkoutProcessing: false,
      successMessage: null,
      portalTabOpen: false,
    };

    this._isMounted = false;
    this.planUrlSet = false;
    this.customerSessionFetched = false;
    this.checkoutRetryCount = 0;
  }

  componentDidMount() {
    // Load Stripe Pricing Table script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);
    
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    const { intl, locationId, locationData, plans, } = this.props;
    this._isMounted = true;

    // Detect checkout completion return
    const params = new URLSearchParams(window.location.search);
    if (params.get('checkout_success') === 'true') {
      this.handleCheckoutReturn();
    }

    const userId = parseInt(getUserId());
    let ref_id = this.encrypt(userId,locationId);
    if(ref_id) {
      this.setState({planUrl: config.basePricingPageUrl+"?ref_id="+ref_id, 
        planButtonText: "View Plans",
        planThirdLineText: "",
      });
    }

    if(plans && plans.length > 0) {
      if(locationData && locationData.plan_id) {
        const cplan = plans.find(plan => plan.id === locationData.plan_id);
        let userId = parseInt(getUserId());
        let ref_id = this.encrypt(userId,locationId);
        if(ref_id) {
          if(cplan.name === "Basic") {
            this.setState({planUrl: config.basePricingPageUrl+"?ref_id="+ref_id,
              planButtonText: "View Plans",
              planThirdLineText: "You do not have an active subscription, purchase a plan from the Subscription Page to unlock additional features.",
            }, () => this.maybeFetchCustomerSession());
          }
          else if(cplan.name === "Trial") {
            this.setState({planUrl: config.basePricingPageUrl+"?ref_id="+ref_id,
              planButtonText: "View Plans",
              planThirdLineText: "Your trial ends on: " + moment(locationData.plan_refresh_date).format('MMMM D, YYYY'),
            }, () => this.maybeFetchCustomerSession());
          }
          else {
            this.setState({planUrl: config.baseShopPageUrl,
              planButtonText: "Manage Plan",
              planThirdLineText: "Current billing cycle: " + this.modifyBillingCycle(locationData.plan_cycle),
            });
            if(locationData.plan_cycle === "monthly") {
              this.setState({planName: cplan.name, planPrice: cplan.month_price});
              if(cplan.name === "Starter") {
                this.setState({planFourthLineText: "Switch to annual billing and get 14% off the price of your subscription."});
              } else if(cplan.name === "Advanced") {
                this.setState({planFourthLineText: "Switch to annual billing and get 15.8% off the price of your subscription."});
              } else if(cplan.name === "Professional") {
                this.setState({planFourthLineText: "Switch to annual billing and get 16% off the price of your subscription."});
              } else{
              }
            } else {
              this.setState({planName: cplan.name, planPrice: cplan.year_price});
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { plans, locationData, locationId } = this.props;
    if(plans && plans.length > 0) {
      if(locationData && locationData.plan_id) {
        if(!this.planUrlSet) {
          this.planUrlSet = true;
          const cplan = plans.find(plan => plan.id === locationData.plan_id); //find what plan the location is on
          this.setState({planName: cplan.name, 
            planPrice: cplan.month_price});
          let userId = parseInt(getUserId());
          let ref_id = this.encrypt(userId,locationId);
          if(ref_id) {
            if(cplan.name === "Basic") {
              this.setState({planUrl: config.basePricingPageUrl+"?ref_id="+ref_id,
                planButtonText: "View Plans",
                planThirdLineText: "You do not have an active subscription, subscribe to one of our plans below to unlock additional features.",
              }, () => this.maybeFetchCustomerSession());
            }
            else if(cplan.name === "Trial") {
              this.setState({planUrl: config.basePricingPageUrl+"?ref_id="+ref_id,
                planButtonText: "View Plans",
                planThirdLineText: "Your trial ends on: " + moment(locationData.plan_refresh_date).format('MMMM D, YYYY'),
              }, () => this.maybeFetchCustomerSession());
            }
            else {
              this.setState({planUrl: config.baseShopPageUrl,
                planButtonText: "Manage Plan",
                planThirdLineText: "Current billing cycle: " + this.modifyBillingCycle(locationData.plan_cycle),
              });
              if(locationData.plan_cycle === "monthly") {
                this.setState({planName: cplan.name, planPrice: cplan.month_price});
                if(cplan.name === "Starter") {
                  this.setState({planFourthLineText: "Switch to annual billing and get 14% off the price of your subscription."});
                } else if(cplan.name === "Advanced") {
                  this.setState({planFourthLineText: "Switch to annual billing and get 15.8% off the price of your subscription."});
                } else if(cplan.name === "Professional") {
                  this.setState({planFourthLineText: "Switch to annual billing and get 16% off the price of your subscription."});
                } else {
                }
              } else {
                this.setState({planName: cplan.name, planPrice: cplan.year_price});
              }
            }
          }
        }
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  maybeFetchCustomerSession() {
    const { locationData, locationId } = this.props;
    const { planName } = this.state;

    const shouldShowPricingTable = !planName || planName === "Trial" || planName === "Basic";
    if (
      !this.customerSessionFetched &&
      shouldShowPricingTable &&
      locationData &&
      locationData.plan_stripe_customer_id
    ) {
      this.customerSessionFetched = true;
      this.setState({ pricingTableLoading: true });

      createCustomerSession(locationId, { pricing_table: { enabled: true } })
        .then((clientSecret) => {
          if (this._isMounted) {
            this.setState({ customerSessionSecret: clientSecret, pricingTableLoading: false });
          }
        })
        .catch((error) => {
          console.error('Failed to fetch customer session, falling back to basic pricing table:', error);
          if (this._isMounted) {
            this.setState({ pricingTableLoading: false });
          }
        });
    }
  }

  handleCheckoutReturn() {
    // Clear the query param to prevent re-triggering on refresh
    const url = new URL(window.location.href);
    url.searchParams.delete('checkout_success');
    window.history.replaceState({}, '', url.pathname + url.search);

    this.setState({ checkoutProcessing: true, checkoutSuccess: true });
    this.refreshAndCheckPlan();
  }

  refreshAndCheckPlan() {
    const { refreshLocationData, locationData } = this.props;
    const maxRetries = 3;
    const retryDelay = 2000;

    refreshLocationData();

    // Allow time for the Redux state to update after the dispatch
    setTimeout(() => {
      if (!this._isMounted) return;

      const currentPlanName = this.state.planName;
      const stillOnFreePlan = !currentPlanName || currentPlanName === 'Basic' || currentPlanName === 'Trial';

      if (stillOnFreePlan && this.checkoutRetryCount < maxRetries) {
        this.checkoutRetryCount++;
        setTimeout(() => {
          if (this._isMounted) {
            // Reset planUrlSet to allow componentDidUpdate to re-process the new plan data
            this.planUrlSet = false;
            this.refreshAndCheckPlan();
          }
        }, retryDelay);
      } else {
        // Either plan updated or we've exhausted retries
        if (stillOnFreePlan) {
          this.setState({
            checkoutProcessing: false,
            successMessage: 'Your subscription is being activated. Please refresh the page in a moment to see your updated plan.',
          });
        } else {
          this.setState({
            checkoutProcessing: false,
            successMessage: `Subscription activated! Welcome to the ${currentPlanName} plan.`,
          });
        }
      }
    }, 1500);
  }

  dismissSuccessMessage = () => {
    this.setState({ successMessage: null, checkoutSuccess: false });
  };

  handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible' || !this.state.portalTabOpen) return;
    if (!this._isMounted) return;

    const { refreshLocationData } = this.props;

    this.setState({ portalTabOpen: false });
    this.planUrlSet = false;
    refreshLocationData();

    // Allow time for Redux state to propagate, then check for plan changes
    setTimeout(() => {
      if (!this._isMounted) return;
      const newPlanName = this.state.planName;
      const prev = this.previousPlanName;

      if (prev && newPlanName && prev !== newPlanName) {
        if (newPlanName === 'Basic') {
          this.setState({ successMessage: 'Subscription cancelled.' });
        } else {
          this.setState({ successMessage: `Plan updated to ${newPlanName}.` });
        }
      }
    }, 2000);
  };

  encrypt(uid, lid) {
    return (uid*uid + lid*lid + uid + 2*uid*lid + 3*lid)/2;
  }

  modifyBillingCycle(bill_cycle) {
    if(bill_cycle === 'monthly') {
      return 'Monthly';
    } else if(bill_cycle === 'yearly') {
      return 'Annually';
    } else {
      return 'Monthly';
    }
  }

  handleManagePlanClick = async (e) => {
    e.preventDefault();
    const { locationData } = this.props;

    // Store current plan name for comparison when user returns
    this.previousPlanName = this.state.planName;

    if (locationData && locationData.plan_stripe_customer_id) {
      try {
        const portalUrl = await createStripePortalSession(locationData.plan_stripe_customer_id);
        window.open(portalUrl, '_blank');
        this.setState({ portalTabOpen: true });
      } catch (error) {
        console.error('Error creating portal session:', error);
        window.open(config.baseShopPageUrl, '_blank');
        this.setState({ portalTabOpen: true });
      }
    } else {
      window.open(config.baseShopPageUrl, '_blank');
      this.setState({ portalTabOpen: true });
    }
  };

  render() {
    const { planName, planPrice, planUrl, planButtonText, planThirdLineText, planFourthLineText, customerSessionSecret, pricingTableLoading, checkoutProcessing, successMessage, portalTabOpen } = this.state;

    const userId = parseInt(getUserId());
    const clientReferenceId = this.encrypt(userId, this.props.locationId);

    // Check if plan is Trial or Basic
    const shouldHideButton = planName === "Trial" || planName === "Basic";
    
    // Determine if we should show the pricing table
    const shouldShowPricingTable = !planName || planName === "Trial" || planName === "Basic";

    return (
      <div className="subscription-container">
        {successMessage && (
          <div className="checkout-success-banner">
            <span>{successMessage}</span>
            <button className="dismiss-btn" onClick={this.dismissSuccessMessage}>&times;</button>
          </div>
        )}

        {checkoutProcessing && (
          <div className="checkout-processing">
            <div className="pricing-table-spinner" />
            <span>Setting up your subscription...</span>
          </div>
        )}

        {portalTabOpen && (
          <div className="portal-open-message">
            <span>Managing your plan in another tab...</span>
          </div>
        )}

        <div className="view-plan-subscribed">
          <div className="overlap">
            <div className="row">Current Shyft Plan</div>
            <div className="content-wrapper">
              {/* Left section - 50% */}
              <div className="content-section left">
                <div className="text-wrapper">{planName}</div>
                <div className="plan-description">
                  {planThirdLineText}
                  {planFourthLineText && <><br/><br/>{planFourthLineText}</>}
                </div>
              </div>

              {/* Middle section - 25% */}
              <div className="content-section middle">
                <div className="flex-container align-items-center">
                  <span className="PriceColumn-price Text Text-color--default Text-fontSize--36 Text-fontWeight--700">
                    <span className="CurrencyAmount">${planPrice}</span>
                  </span>
                  <span className="PriceColumn-interval Text Text-color--default Text-fontSize--13">
                    per <br/>month
                  </span>
                </div>
              </div>

              {/* Right section - 25% */}
              <div className="content-section right">
                {!shouldHideButton && (
                  <div className="group-2">
                    <div className="div-wrapper">
                      <a 
                        className="text-wrapper-3" 
                        href={planUrl ? planUrl : ""} 
                        onClick={planButtonText === "Manage Plan" ? this.handleManagePlanClick : null}
                        target="_blank"
                      >
                        {planButtonText}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        <div className="spacer" style={{ height: '24px' }}></div>

        {shouldShowPricingTable && (
          <div className="view-plan-subscribed">
            <div className="overlap">
              <div className="row">Available Plans</div>
              <div className="stripe-pricing-table-container">
                {pricingTableLoading ? (
                  <div className="pricing-table-loading">
                    <div className="pricing-table-spinner" />
                    <span>Loading plans...</span>
                  </div>
                ) : customerSessionSecret ? (
                  <stripe-pricing-table
                    pricing-table-id={config.stripe.pricingTableId}
                    publishable-key={config.stripe.publishableKey}
                    customer-session-client-secret={customerSessionSecret}>
                  </stripe-pricing-table>
                ) : (
                  <stripe-pricing-table
                    pricing-table-id={config.stripe.pricingTableId}
                    publishable-key={config.stripe.publishableKey}
                    client-reference-id={clientReferenceId}>
                  </stripe-pricing-table>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
}

//export {SubscriptionPage};

export default injectIntl(SubscriptionPage);